<template>
        <vx-card class="mb-1 px-3 pt-4">
            <template slot="no-body">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="demo-alignment custom">
                            <div v-for="(activity, idx) in processFlow" v-bind:key="idx" class="project-status-chip mb-1 completed">
                                <vs-chip
                                transparent
                                class="mb-1"
                                :color="getColorClass(activity.id)">
                                <vs-avatar icon-pack="feather" icon="icon-play" />{{ activity.name }}
                                </vs-chip>
                                <p class="pill-desc mt-1">{{getDate(activity)}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </vx-card>
</template>

<script>
    import * as moment from 'moment'
    import dateHelper from '@mixins/dateHelper';
    export default {
        name: "ProjectLifeCycle",
        props: {
            project: {
                type: Object,
                required: true,
                default: {}
            }
        },
        mixins: [dateHelper],
        data: () => ({
            processFlow: [
                {
                    name: "Creación",
                    status: "done",
                    priority: "low",
                    depth: 'client',
                    id: 0.01,
                    date: ""
                },
                {
                    name: "Solic. a revisión",
                    status: "done",
                    priority: "high",
                    depth: 'client',
                    id: 0.1,
                    date: ""
                },
                {
                    name: "Pre-aprobado",
                    status: "",
                    priority: "low",
                    depth: 'company',
                    strong: true,
                    id: 3,
                    date: ""
                },
                {
                    name: "Solic. completa",
                    status: "",
                    priority: "high",
                    depth: 'client',
                    id: 3.1,
                    date: ""
                },
                {
                    name: "Aprobación",
                    status: "",
                    priority: "low",
                    strong: true,
                    depth: 'company',
                    id: 4,
                    date: ""
                },
                {
                    name: "Envío de oferta",
                    status: "",
                    priority: "low",
                    strong: true,
                    depth: 'company',
                    id: 4,
                    date: ""
                },
                {
                    name: "Documentos verificados",
                    status: "",
                    priority: "low",
                    depth: 'company',
                    id: 4.2,
                    date: ""
                },
                {
                    name: "Pre-Fondeo",
                    status: "",
                    priority: "high",
                    depth: 'company',
                    id: 4.1,
                    date: ""
                },
                {
                    name: "Publicación",
                    status: "",
                    priority: "low",
                    strong: true,
                    depth: 'company',
                    id: 5,
                    date: ""
                },
                {
                    name: "Fondeado",
                    status: "",
                    priority: "high",
                    depth: 'supplier',
                    id: 5.1,
                    date: ""
                },
                {
                    name: "Envio de contratos",
                    status: "",
                    priority: "low",
                    depth: 'company',
                    id: 5.2,
                    date: ""
                },
                {
                    name: "Aceptación contratos",
                    status: "",
                    priority: "high",
                    strong: true,
                    depth: 'company',
                    id: 6,
                    date: ""
                },
                {
                    name: "Primer pago",
                    status: "",
                    priority: "low",
                    depth: 'company',
                    id: 6.1,
                    date: ""
                },
                {
                    name: "Solic. verificación de evidencia",
                    status: "",
                    priority: "low",
                    depth: 'company',
                    id: 6.11,
                    date: ""
                },
                {
                    name: "Aceptación de evidencia",
                    status: "",
                    priority: "high",
                    depth: 'company',
                    id: 6.2,
                    date: ""
                },
                {
                    name: "Segundo pago",
                    status: "",
                    priority: "low",
                    depth: 'company',
                    id: 7.1,
                    date: ""
                }
            ]
        }),
        mounted() {
            moment.locale('es-ES');

            this.processFlow[0].date = this.project.created_at
            this.processFlow[1].date = this.project.review_date != null ? this.project.review_date : '';
            this.processFlow[2].date = this.project.preapproved != null ? this.project.preapproved : '';
            this.processFlow[3].date = this.project.documentation_complete_date != null ? this.project.documentation_complete_date  : '';
            this.processFlow[4].date = this.project.approved_date != null ? this.project.approved_date : '';
            this.processFlow[5].date = this.project.loan_proposal_timestamp != null ? this.project.loan_proposal_timestamp : '';
            this.processFlow[6].date = this.project.all_documents_verified_timestamp != null ? this.project.all_documents_verified_timestamp : '';
            this.processFlow[7].date = this.project.initial_payment_date != null ? this.project.public_date : '';
            this.processFlow[8].date = this.project.public_date != null ? this.project.public_date : '';
            this.processFlow[9].date = this.project.fund_date != null ? this.project.fund_date : '';
            this.processFlow[10].date = this.project.contracts_date != null ? this.project.contracts_date : '';
            this.processFlow[11].date = this.project.contracts_acceptance_date != null ? this.project.contracts_acceptance_date : '';
            this.processFlow[12].date = this.project.installation_date != null ? this.project.installation_date : '';
            this.processFlow[13].date = this.project.evidence_verification_request_date != null ? this.project.evidence_verification_request_date : '';
            this.processFlow[14].date = this.project.complete_evidence_date != null ? this.project.complete_evidence_date  : '';
            this.processFlow[15].date = this.project.delivery_date != null ? this.project.delivery_date : '';

        },
        watch: {
            'project.review_date': function(){
                this.processFlow[1].date = this.project.review_date != null ? this.project.review_date : '';
            },
            'project.documentation_complete_date': function(){
                this.processFlow[3].date = this.project.documentation_complete_date != null ? this.project.documentation_complete_date  : '';
            },
        },
        methods: {
            getColorClass(s){
                if(s <= this.project.status){
                    return "primary";
                }
                else {
                    return "na";
                }
            },
            getDate(s){
                const dd = s.date;
                if(dd !== null && dd !== ''){
                    return this.compactDateFormat(dd);
                }
                else {
                    return "--";
                }
            }
        }
    }
</script>

<style scoped>
.activity-name-text {
    line-height: 1;
}

.project-status-chip.completed .pill-desc {
  color: black;
}
.project-status-chip.current .pill-desc {
  color: rgba(var(--vs-warning),1);
}
.project-status-chip .pill-desc {
  color: rgba(0,0,0,.7);
  text-align: center;
  font-size: 10px;
}
.demo-alignment.custom > *{
  margin-right: 1rem;
}
</style>
